import { remoteDB } from '../integrations/pouch/DBConn';
import { getSessionInfo } from './getSessionInfo';
import { updatePinCodeStatus, createPinCodeStatus } from './pincode';
import { removeSession, saveSession } from './storage';
import { Tracking } from '../analytics/tracking';
import { captureException } from '../integrations/sentry/capture';
import { getEnvs } from './getEnvs';

export const logoutUser = async () => {
	const { shoppaUser } = getSessionInfo();
	try {
		const { user } = getEnvs();
		const { userInfo } = getSessionInfo();
		if (userInfo) {
			const resetUser = {
				...userInfo,
				assignedLocations: [],
			};
			saveSession(user, resetUser);
		}

		await remoteDB('').logOut();
		await createPinCodeStatus(false);
		await updatePinCodeStatus(false);
		removeSession(shoppaUser);
		Tracking.reset();
		window.location.href = '/login';
		setTimeout(() => {
			window.location.reload();
		}, 500);
	} catch (err) {
		captureException(err, { fn: 'logoutUser' });
		removeSession(shoppaUser);
		window.location.href = '/login';

		Tracking.reset();

		setTimeout(() => {
			window.location.reload();
		}, 500);
	}
};
